// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__fkyKg","calendarButtons":"ClockData_calendarButtons___1C54"};